module.exports = __webpack_public_path__ + "img/ic-menu-filter.f27e7451.svg";